<template>
  <div class="d-md-flex justify-start align-start d-block">
    <div>
      <div class="_fs-20 _lh-24 _fw-700 _tc-dark">
        {{ $t('interface.support.title') }}
      </div>
      <div class="_fs-16 _lh-24 _tc-dark-grey">
        {{ $t('interface.support.description') }}
      </div>
    </div>
    <AppBtn
      @click.native="telegramClick()"
      class="_ml-auto _mt-sm-4 w-100 w-md-auto"
      :btnClass="'btn_blue'"
    >
      <a
        href="https://t.me/+fR3ci9egP2tkZjc6"
        class="_px-8 _py-2 _tc-white"
        target="_blank"
      >
        <span class="_fs-16 _lh-24">Telegram</span>
      </a>
    </AppBtn>
  </div>
</template>

<script>
import AppBtn from '../buttons/AppBtn.vue'
export default {
  components: { AppBtn },
  props: {
    analyticEventPrefix: { type: String, default: 'auth' },
  },
  name: 'Telegram',
  methods: {
    telegramClick() {
      if (this.$gtm) {
        this.$gtm.push({
          event: this.analyticEventPrefix + '_telegram_support',
        })
      }
    },
  },
}
</script>

<style></style>
